import React, { useCallback } from 'react';
import { LazyComponent as LazyComponentUtils } from '@fiverr-private/ui_utils';
import { logger, stats } from '@fiverr-private/obs';
import { useMetricBase } from '../../hooks/useMetricBase';

type LazyComponentUtilsProps = React.ComponentProps<typeof LazyComponentUtils>;

interface LazyComponentProps
    extends Pick<LazyComponentUtilsProps, 'lazyImport' | 'componentProps'>,
        React.PropsWithChildren<Partial<Omit<LazyComponentUtilsProps, 'lazyImport' | 'componentProps'>>> {
    moduleName: string;
}

export const LazyComponent: React.FC<LazyComponentProps> = ({ moduleName, children, ...props }) => {
    const statsPrefix = useMetricBase();

    const onError = useCallback(
        (e) => {
            logger.warn(`Failed to lazy load component "${moduleName}"`, e);
            stats.count(statsPrefix, 'error');
        },
        [moduleName, statsPrefix]
    );

    const componentProps = children ? Object.assign(props.componentProps ?? {}, { children }) : props.componentProps;

    return <LazyComponentUtils {...props} componentProps={componentProps} onError={onError} />;
};
